import {
    DEFAULT_OFFER_IMAGE,
    EXTENSION_PREVIEW_SKIP_BTN_CLASS_FACTORY,
} from "../../conf";
import { RENDER_EXTENSION_PREVIEW } from "./renderExtensionNew";

export const EXTENSION_OFFER_TOGGLE_CLASS = "extension-offer-toggle-btn";
const renderExtensionOffer = ({
    display_text: displayText = "",
    show_timer: showTimer = false,
    duration: offerDuration = 30,
    percentage_discount: percentageDiscount = false,
    heading: offerHeading = "Your offer heading",
    discount,
    actualPrice,
    discountedPrice,
    product,
    publisher_details: publisherDetails,
    brand_description: brandDescription,
    cross_sell: isCrossSell,
    interactions: { open },
}) => {
    const isDiscountZero = discount !== null && Number(discount) === 0;
    const brandOfferDescription =
        brandDescription ||
        publisherDetails?.description ||
        publisherDetails?.single_liner;

    return RENDER_EXTENSION_PREVIEW(`
	<div
    style="
        --x-pp-color-canvas: rgb(255, 255, 255);
        --x-pp-color-canvas-subdued: rgb(250, 250, 250);
        --x-pp-color-canvas-text: rgb(88, 88, 88);
        --x-pp-color-canvas-text-subdued: rgb(119, 119, 119);
        --x-pp-color-canvas-text-emphasized: rgb(64, 51, 49);
        --x-pp-color-canvas-border: rgb(230, 230, 230);
        --x-pp-color-canvas-border-emphasized: rgb(64, 51, 49);
        --x-pp-color-surface-primary: rgb(255, 255, 255);
        --x-pp-color-surface-primary-disabled: rgb(248, 248, 248);
        --x-pp-color-surface-primary-subdued: rgb(250, 250, 250);
        --x-pp-color-surface-primary-text: rgb(88, 88, 88);
        --x-pp-color-surface-primary-text-subdued: rgb(119, 119, 119);
        --x-pp-color-surface-primary-text-emphasized: rgb(64, 51, 49);
        --x-pp-color-surface-primary-border: rgb(230, 230, 230);
        --x-pp-color-surface-primary-border-emphasized: rgb(64, 51, 49);
        --x-pp-color-surface-secondary: rgb(250, 250, 250);
        --x-pp-color-surface-secondary-disabled: rgb(243, 243, 243);
        --x-pp-color-surface-secondary-subdued: rgb(245, 245, 245);
        --x-pp-color-surface-secondary-text: rgb(84, 84, 84);
        --x-pp-color-surface-secondary-text-subdued: rgb(115, 115, 115);
        --x-pp-color-surface-secondary-text-emphasized: rgb(61, 47, 45);
        --x-pp-color-surface-secondary-border: rgb(225, 225, 225);
        --x-pp-color-surface-secondary-border-emphasized: rgb(61, 47, 45);
        --x-pp-color-primary-action: #1879b9;
        --x-pp-color-primary-action-hovered: #115e92;
        --x-pp-color-primary-action-pressed: #115e92;
        --x-pp-color-primary-action-text: #fff;
        --x-pp-color-primary-action-text-hovered: #fff;
        --x-pp-color-primary-action-text-pressed: #fff;
        --x-pp-color-interactive-text: rgb(24, 120, 185);
        --x-pp-color-interactive-text-hovered: rgb(32, 146, 224);
        --x-pp-color-interactive-text-pressed: rgb(32, 146, 224);
        --x-pp-color-critical-accent: rgb(226, 33, 32);
        --x-pp-typography-primary-fonts: -apple-system, BlinkMacSystemFont,
            'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
            'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', sans-serif;
        --x-pp-typography-primary-weight-bold: 500;
        --x-pp-typography-secondary-fonts: -apple-system, BlinkMacSystemFont,
            'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
            'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', sans-serif;
        --x-pp-typography-secondary-weight-bold: -apple-system,
            BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
            'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    "
>
    <div class="_1TiSn _2qO1A">
        <div class="_3wX9T _3DN_h">
            <div class="_3wX9T">
                <div class="_3wX9T"><div class="_2KoLb _3g0oA"></div></div>
                <div class="_11iiE Layout6">
                    <style>
                        @media all and (max-width: 749px) {
                            .Layout6 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 100%;
                                max-width: 100%;
                            }
                            .Layout6 > ._2Q-zx {
                                flex-wrap: wrap;
                            }
                            .Layout6 > ._2Q-zx {
                                max-width: 90%;
                            }
                        }
                        @media all and (min-width: 750px) and (max-width: 1199px) {
                            .Layout6 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 100%;
                                max-width: 100%;
                            }
                            .Layout6 > ._2Q-zx {
                                flex-wrap: wrap;
                            }
                            .Layout6 > ._2Q-zx {
                                max-width: 80%;
                            }
                        }
                        @media all and (min-width: 1200px) {
                            .Layout6 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 100%;
                                max-width: 100%;
                            }
                            .Layout6 > ._2Q-zx {
                                flex-wrap: wrap;
                            }
                            .Layout6 > ._2Q-zx {
                                max-width: 100rem;
                            }
                        }
                    </style>
                    <div class="_2Q-zx">
                        <div class="_32qEx _1IgVl _1PFsb">
                            <div class="">
                                <button
                                    type="button"
                                    class="_27XPT _2nHLH _1NG2H"
                                    aria-busy="false"
                                    aria-live="polite"
                                >
                                    <span class="_1nMwn"
                                        ><div class="_11iiE Layout7">
                                            <style>
                                                .Layout7 > ._2Q-zx {
                                                    max-width: 25rem;
                                                }
                                            </style>
                                            <div class="_2Q-zx">
                                                <img
                                                    src="https://coopcommerce.s3.us-west-1.amazonaws.com/pp-extension/order-confirmation.png"
                                                    alt=""
                                                    class="_2Tcm5"
                                                />
                                            </div></div
                                    ></span>
                                </button>
                            </div>
                            <button
                                type="button"
                                class="_27XPT _2nHLH _1NG2H ${EXTENSION_PREVIEW_SKIP_BTN_CLASS_FACTORY(
                                    "x"
                                )}"
                                aria-busy="false"
                                aria-live="polite"
                            >
                                <span class="_1nMwn"
                                    ><div class="_11iiE Layout8">
                                        <style>
                                            .Layout8 > ._2Q-zx {
                                                max-width: 5.4rem;
                                            }
                                        </style>
                                        <div class="_2Q-zx">
                                            <img
                                                src="https://coopcommerce.s3.us-west-1.amazonaws.com/pp-extension/cross-btn.png"
                                                alt=""
                                                class="_2Tcm5"
                                            />
                                        </div></div
                                ></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
             ${
                 isCrossSell && publisherDetails
                     ? `<div class="_3wX9T">
                <div class="_3wX9T"><div class="_2KoLb _3g0oA"></div></div>
                <div class="_11iiE Layout9">
                    <style>
                        @media all and (max-width: 749px) {
                            .Layout9 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 100%;
                                max-width: 100%;
                            }
                            .Layout9 > ._2Q-zx {
                                flex-wrap: wrap;
                            }
                            .Layout9 > ._2Q-zx {
                                max-width: 90%;
                            }
                        }
                        @media all and (min-width: 750px) and (max-width: 1199px) {
                            .Layout9 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 100%;
                                max-width: 100%;
                            }
                            .Layout9 > ._2Q-zx {
                                flex-wrap: wrap;
                            }
                            .Layout9 > ._2Q-zx {
                                max-width: 80%;
                            }
                        }
                        @media all and (min-width: 1200px) {
                            .Layout9 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 100%;
                                max-width: 100%;
                            }
                            .Layout9 > ._2Q-zx {
                                flex-wrap: wrap;
                            }
                            .Layout9 > ._2Q-zx {
                                max-width: 100rem;
                            }
                        }
                    </style>
                    <div class="_2Q-zx">
                        <div class="_3wX9T">
                            <div
                                class="M6x6M _24GPq"
                                style="border-bottom-width: 1px"
                            ></div>
                            <div class="_3wX9T _1FdNY">
                                Exclusive offer from
                                <div class="_3qJyW -ropj">
                                    <div class="_11iiE Layout10">
                                        <style>
                                            .Layout10 > ._2Q-zx {
                                                max-width: 6rem;
                                            }
                                        </style>
                                        <div class="_2Q-zx">
                                            <img
                                                src="${
                                                    publisherDetails?.logo_url
                                                }"
                                                alt=""
                                                class="_2Tcm5"
                                            />
                                        </div>
                                    </div>
                                    <div class="_3wX9T _38sPw _3DN_h">
                                        <div class="_3qJyW _3XTCL _1mnjF">
                                            <strong
                                                class="_2YaAO _35JM8 _2NKKz _2_NS0"
                                                >${
                                                    publisherDetails?.name
                                                }</strong
                                            ><button
                                                type="button"
                                                class="_27XPT _2nHLH _1NG2H ${EXTENSION_OFFER_TOGGLE_CLASS}"
                                                aria-busy="false"
                                                aria-live="polite"
                                            >
                                                <span class="_1nMwn"
                                                    ><div
                                                        class="_11iiE Layout11"
                                                    >
                                                        <style>
                                                            .Layout11
                                                                > ._2Q-zx {
                                                                max-width: 1.6rem;
                                                            }
                                                        </style>
                                                        <div class="_2Q-zx">
                                                            <img
                                                                src="https://coopcommerce.s3.us-west-1.amazonaws.com/pp-extension/arrow-up-light.png"
                                                                alt=""
                                                                class="_2Tcm5"
                                                            />
                                                        </div></div
                                                ></span>
                                            </button>
                                        </div>
                                        ${
                                            open
                                                ? `
                                            <span class="_2YaAO _1Tomy _3XSfq">
                                                ${brandOfferDescription}
                                            </span>
                                        `
                                                : ""
                                        }<a
                                            class="_27XPT _2nHLH _1NG2H"
                                            href="${
                                                publisherDetails?.shopify_shop
                                            }"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            ><span class="_1nMwn"
                                                >Visit Shop</span
                                            ></a
                                        >
                                    </div>
                                </div>
                            </div>
                            <div
                                class="M6x6M _24GPq"
                                style="border-bottom-width: 1px"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>`
                     : ""
             }
            <div class="_3wX9T">
                <div class="_3wX9T"><div class="_2KoLb _3g0oA"></div></div>
                <div class="_11iiE Layout12">
                    <style>
                        @media all and (max-width: 749px) {
                            .Layout12 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 100%;
                                max-width: 100%;
                            }

                            .Layout12 > ._2Q-zx > :nth-child(2) {
                                flex: 0 0 0%;
                                max-width: 0%;
                            }

                            .Layout12 > ._2Q-zx > :nth-child(3) {
                                flex: 0 0 98%;
                                max-width: 98%;
                            }
                            .Layout12 > ._2Q-zx {
                                flex-wrap: wrap;
                            }
                            .Layout12 > ._2Q-zx {
                                max-width: 90%;
                            }
                        }
                        @media all and (min-width: 750px) and (max-width: 1199px) {
                            .Layout12 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 46%;
                                max-width: 46%;
                            }

                            .Layout12 > ._2Q-zx > :nth-child(2) {
                                flex: 0 0 8%;
                                max-width: 8%;
                            }

                            .Layout12 > ._2Q-zx > :nth-child(3) {
                                flex: 0 0 46%;
                                max-width: 46%;
                            }
                            .Layout12 > ._2Q-zx {
                                max-width: 80%;
                            }
                        }
                        @media all and (min-width: 1200px) {
                            .Layout12 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 46%;
                                max-width: 46%;
                            }

                            .Layout12 > ._2Q-zx > :nth-child(2) {
                                flex: 0 0 8%;
                                max-width: 8%;
                            }

                            .Layout12 > ._2Q-zx > :nth-child(3) {
                                flex: 0 0 46%;
                                max-width: 46%;
                            }
                            .Layout12 > ._2Q-zx {
                                max-width: 100rem;
                            }
                        }
                    </style>
                    <div class="_2Q-zx">
                        <div class="_3wX9T">
                            <strong class="_2YaAO _35JM8 _2NKKz _2_NS0"
                                >${offerHeading}</strong
                            >
                            ${
                                showTimer
                                    ? `
                                    <div class="_3j0kx _1d0rJ" role="status" aria-atomic="true" aria-live="polite">
                                        <div class="_32qEx">
                                            <div class="_2eybg _1iKs5">
                                                <div>
                                                    <div class="">
                                                        <div class="_2eybg SsbUH">
                                                            <strong class="_2YaAO _35JM8 _2NKKz"
                                                                >This offer expires in ${offerDuration} seconds</strong
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                `
                                    : ""
                            }
                            <div class="_3wX9T">
                                <div
                                    class="k6vSC"
                                    style="padding-bottom: calc(100%)"
                                >
                                    <img alt="" src="${
                                        product?.photo_url ||
                                        DEFAULT_OFFER_IMAGE
                                    }" class="_2Tcm5 _1h6pI" />
                                </div>
                                <div class="_3wX9T">
                                    <div class="_2KoLb"></div>
                                </div>
                            </div>
                        </div>
                        <div class=""></div>
                        <div class="_3wX9T">
                            <strong class="_2YaAO _35JM8 _2NKKz _2_NS0"
                                >${product.name}</strong
                            ><span class="_2YaAO _1Tomy _3XSfq">${displayText}</span>
                            <div class="_3wX9T">
                                <div class="_11iiE Layout15">
                                    <style>
                                        .Layout15 > ._2Q-zx > :nth-child(1) {
                                            flex: 0 0 50%;
                                            max-width: 50%;
                                        }

                                        .Layout15 > ._2Q-zx > :nth-child(2) {
                                            flex: 0 0 50%;
                                            max-width: 50%;
                                        }
                                    </style>
                                    <div class="_2Q-zx">
                                        <div class="_32qEx _2kZQ5 b085l">
                                            <strong
                                                class="_2YaAO _35JM8 _2NKKz xq3CF ejXgY"
                                                >$${discountedPrice}</strong
                                            >${
                                                !isDiscountZero
                                                    ? `<del
                                                class="_2YaAO _1Tomy _3XSfq xq3CF"
                                                >$${
                                                    typeof actualPrice ===
                                                    "number"
                                                        ? actualPrice.toFixed(2)
                                                        : actualPrice
                                                }</del
                                            >`
                                                    : ""
                                            }
                                        </div>
                                        <div class="_32qEx _1IgVl">
                                            <div class=""></div>
                                            ${
                                                !isDiscountZero
                                                    ? `
                                                <strong
                                                    class="_2YaAO _35JM8 _2NKKz bwSls"
                                                    >${
                                                        !percentageDiscount
                                                            ? `$${Number(
                                                                  discount
                                                              )}`
                                                            : `${Number(
                                                                  discount
                                                              )}%`
                                                    }
                                                    Off</strong
                                                >
                                            `
                                                    : ""
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="M6x6M _24GPq"
                                    style="border-bottom-width: 1px"
                                ></div>
                                <div class="_11iiE Layout16">
                                    <style>
                                        .Layout16 > ._2Q-zx > :nth-child(1) {
                                            flex: 0 0 10rem;
                                            max-width: 10rem;
                                        }

                                        .Layout16 > ._2Q-zx > :nth-child(2) {
                                            flex: 1 1 auto;
                                            max-width: auto;
                                        }
                                    </style>
                                    <div class="_2Q-zx">
                                        <div class="_2eybg">
                                            <span class="_2YaAO _1Tomy _3XSfq"
                                                >Subtotal</span
                                            >
                                        </div>
                                        <div class="_2eybg T8_jN _coop-extension-dummy-block">
                                            <span class="_2YaAO">$95.00</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="_11iiE Layout17">
                                    <style>
                                        .Layout17 > ._2Q-zx > :nth-child(1) {
                                            flex: 0 0 10rem;
                                            max-width: 10rem;
                                        }

                                        .Layout17 > ._2Q-zx > :nth-child(2) {
                                            flex: 1 1 auto;
                                            max-width: auto;
                                        }
                                    </style>
                                    <div class="_2Q-zx">
                                        <div class="_2eybg">
                                            <span class="_2YaAO _1Tomy _3XSfq"
                                                >Shipping</span
                                            >
                                        </div>
                                        <div class="_2eybg T8_jN _coop-extension-dummy-block">
                                            <span class="_2YaAO">Free</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="_11iiE Layout18">
                                    <style>
                                        .Layout18 > ._2Q-zx > :nth-child(1) {
                                            flex: 0 0 10rem;
                                            max-width: 10rem;
                                        }

                                        .Layout18 > ._2Q-zx > :nth-child(2) {
                                            flex: 1 1 auto;
                                            max-width: auto;
                                        }
                                    </style>
                                    <div class="_2Q-zx">
                                        <div class="_2eybg">
                                            <span class="_2YaAO _1Tomy _3XSfq"
                                                >Taxes</span
                                            >
                                        </div>
                                        <div class="_2eybg T8_jN _coop-extension-dummy-block">
                                            <span class="_2YaAO">$6.89</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="_11iiE Layout19">
                                    <style>
                                        .Layout19 > ._2Q-zx > :nth-child(1) {
                                            flex: 0 0 10rem;
                                            max-width: 10rem;
                                        }

                                        .Layout19 > ._2Q-zx > :nth-child(2) {
                                            flex: 1 1 auto;
                                            max-width: auto;
                                        }
                                    </style>
                                    <div class="_2Q-zx">
                                        <div class="_2eybg">
                                            <strong
                                                class="_2YaAO _35JM8 _2NKKz _1Tomy _3XSfq"
                                                >Total</strong
                                            >
                                        </div>
                                        <div class="_2eybg T8_jN _coop-extension-dummy-block">
                                            <strong class="_2YaAO _35JM8 _2NKKz"
                                                >$101.89</strong
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="_3wX9T">
                                <div class="_2KoLb _3g0oA"></div>
                            </div>
                            <div class="_3wX9T">
                                <div class="_3wX9T _1FdNY">
                                    <div>
                                        <div class="_3AzXF">
                                            <label
                                                class="_2zgRv _1Wz50 _1IK-E"
                                                for="Select0"
                                                ><span
                                                    class="_2YaAO _1Tomy _3XSfq _5Ye68"
                                                    ><span class="_37dyE PSpG1"
                                                        >Quantity</span
                                                    ></span
                                                ></label
                                            ><select
                                                id="Select0"
                                                class="_3P_az _1Nagt _1BCLF _2jofo"
                                                aria-invalid="false"
                                            >
                                                <option value="1">1</option>
                                            </select>
                                            <div class="_2weOU _3m3mt">
                                                <span class="zIGP7 _1Pbnx"
                                                    ><svg
                                                        viewBox="0 0 20 20"
                                                        class="_3eqwU"
                                                        focusable="false"
                                                        aria-hidden="true"
                                                        role="presentation"
                                                    >
                                                        <path
                                                            d="M0 5h20L10 15"
                                                        ></path></svg
                                                ></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="_3wX9T">
                                    <div class="_2KoLb _3g0oA"></div>
                                </div>
                                <button
                                    type="button"
                                    class="_27XPT _2nHLH"
                                    aria-busy="false"
                                    aria-live="polite"
                                >
                                    <span class="_1nMwn">Buy Now</span>
                                </button>
                                <div class="_3wX9T">
                                    <div class="_2KoLb _3g0oA"></div>
                                </div>
                                <button
                                    type="button"
                                    class="_27XPT _2nHLH _1NG2H"
                                    aria-busy="false"
                                    aria-live="polite"
                                >
                                    <span class="_1nMwn"
                                        ><span class="_2YaAO _1Tomy _3XSfq ${EXTENSION_PREVIEW_SKIP_BTN_CLASS_FACTORY(
                                            0
                                        )}"
                                            >No thanks</span
                                        ></span
                                    >
                                </button>
                            </div>
                            <div class="_3wX9T">
                                <div class="_2KoLb _3g0oA"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="_3wX9T">
                <div class="_11iiE Layout14">
                    <style>
                        @media all and (max-width: 749px) {
                            .Layout14 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 100%;
                                max-width: 100%;
                            }
                            .Layout14 > ._2Q-zx {
                                flex-wrap: wrap;
                            }
                            .Layout14 > ._2Q-zx {
                                max-width: 90%;
                            }
                        }
                        @media all and (min-width: 750px) and (max-width: 1199px) {
                            .Layout14 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 100%;
                                max-width: 100%;
                            }
                            .Layout14 > ._2Q-zx {
                                flex-wrap: wrap;
                            }
                            .Layout14 > ._2Q-zx {
                                max-width: 80%;
                            }
                        }
                        @media all and (min-width: 1200px) {
                            .Layout14 > ._2Q-zx > :nth-child(1) {
                                flex: 0 0 100%;
                                max-width: 100%;
                            }
                            .Layout14 > ._2Q-zx {
                                flex-wrap: wrap;
                            }
                            .Layout14 > ._2Q-zx {
                                max-width: 100rem;
                            }
                        }
                    </style>
                    <div class="_2Q-zx">
                        <div
                            class="_3j0kx _1d0rJ"
                            role="status"
                            aria-atomic="true"
                            aria-live="polite"
                        >
                            <div class="_32qEx">
                                <div class="_2eybg _1iKs5">
                                    <div>
                                        <div class="">
                                            Powered by
                                            <a
                                                class="_27XPT _2nHLH _1NG2H"
                                                href="http://consumer.disconetwork-staging.com/core/extension_collective_click/?publisher=ediths-mansion&amp;checkout_token=f4a9e24094e55cb01a27a7355d483a20"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                ><span class="_1nMwn"
                                                    >Disco</span
                                                ></a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

	`);
};

export default renderExtensionOffer;
